<header class="cy-public-header">
    <mat-toolbar color="primary" id="header" class="cyToolbar">
        <mat-toolbar-row>
            <span class="logo">
                <h1>Cypher System</h1>
            </span>
            <span class="version-label">
                Version: {{'VERSION' | env}}
            </span>
            <span class="header-spacer"></span>
            <app-theme-toggle></app-theme-toggle>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
